import { render, staticRenderFns } from "./RecommendationSliders.vue?vue&type=template&id=7bb3ed96&scoped=true"
import script from "./RecommendationSliders.vue?vue&type=script&lang=js"
export * from "./RecommendationSliders.vue?vue&type=script&lang=js"
import style0 from "./RecommendationSliders.vue?vue&type=style&index=0&id=7bb3ed96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb3ed96",
  null
  
)

export default component.exports